import MyRemoteVideo from '@components/MyRemoteVideo';
import PeerVideos from '@components/PeerVideos';
import InterviewerFeatureController from '@fragments/FeatureController/Interviewer';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { useAppState } from '@providers/AppStateProvider';
import { attendeeInfo } from '@stores/selectors/loginInfo';
import { useAtomValue } from 'jotai';
import { Container, IntervieweeInfo, InterviewersArea } from './style';

const WaitingHeader = () => {
  const { recruitNoticeName } = useAtomValue(attendeeInfo);
  const { getInterviewInfo } = useInterviewSession();
  const { joinInfo } = useAppState();
  const { certificationCode } = getInterviewInfo();

  return (
    <Container>
      <IntervieweeInfo>
        {`${recruitNoticeName}`} <br />
        {`${joinInfo?.Name}(${certificationCode})`}
      </IntervieweeInfo>

      <InterviewerFeatureController />

      <InterviewersArea>
        <MyRemoteVideo />
        <PeerVideos />
      </InterviewersArea>
    </Container>
  );
};

export default WaitingHeader;
